import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAccess, Capability } from '../../../hooks/useAccess';

/**
 * Settings landing redirect. Sends each caller to a page they can actually open
 * — the destination must match what V3SettingsLayout's nav filter shows, or the
 * caller lands on a guarded route and gets bounced out of Settings.
 *
 * Decided on the real RBAC capabilities (not the legacy JWT role): a legacy
 * `role === 'admin'` is held by ORGANISATION admins too, so keying off it sent
 * them to the platform-only `features-visibility` and AdminRoute bounced them
 * to /v4 — Settings was unreachable for them.
 */
const V3SettingsIndex: React.FC = () => {
  const { can, isLoading } = useAccess();

  // Wait for capabilities so we don't redirect to a guarded page before they
  // resolve (then correct ourselves on the next render).
  if (isLoading) return <div>Loading...</div>;

  // Platform admin: internal landing. Organisation admin: the consolidated
  // Users & Permissions page. Everyone else: Organisation Details, which is
  // ungated and always visible.
  if (can(Capability.PlatformManage)) return <Navigate to="features-visibility" replace />;
  if (can(Capability.FirmManage)) return <Navigate to="users" replace />;
  return <Navigate to="organization" replace />;
};

export default V3SettingsIndex;
